import { isAdmin, isAnyAdmin } from 'permissions/v1/roles';
import {
  canList,
  canView,
  canCreate,
  canUpdate,
  canDestroy,
  noPermissions,
} from 'permissions/v1/index';
import { hasWorkflows } from 'permissions/v1/preferences';

const permission = 'CardTemplate';

const list = (profile) => isAnyAdmin(profile) || canList(permission, profile);
const view = (profile) => isAnyAdmin(profile) || canView(permission, profile);
const create = (profile) => isAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAdmin(profile) || canDestroy(permission, profile);

const permissions = (profile) => {
  if (!hasWorkflows(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
  };
};

export default permissions;
